export const TIMER_AUDIO_EVENTS = [
  ['level-up', 'Next blind level'],
  ['before-break-30', '30 seconds before break'],
  ['before-break-10', '10 seconds before break'],
  ['break-start', 'Break starts'],
  ['break-end', 'Break ends'],
  ['final-30', 'Final level: 30 seconds'],
  ['final-10', 'Final level: 10 seconds'],
  ['final-end', 'Final level ends'],
] as const;

export type TimerAudioEvent = (typeof TIMER_AUDIO_EVENTS)[number][0];
export type TimerAudioSound = 'blinds-up' | 'countdown';
export type TimerAudioVolume = 0.75 | 0.5 | 0.25 | 0;
export interface TimerAudioCue {
  sound: TimerAudioSound;
  volume: TimerAudioVolume;
}
export type TimerAudioConfig = Record<TimerAudioEvent, TimerAudioCue>;

export function normalizeTimerAudio(raw: unknown): TimerAudioConfig {
  const rows = raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {};
  return Object.fromEntries(
    TIMER_AUDIO_EVENTS.map(([event]) => {
      const value = rows[event];
      const cue = value && typeof value === 'object' ? (value as Partial<TimerAudioCue>) : {};
      return [
        event,
        {
          sound:
            cue.sound === 'blinds-up' || cue.sound === 'countdown'
              ? cue.sound
              : event === 'level-up' || event === 'break-end'
                ? 'blinds-up'
                : 'countdown',
          volume: cue.volume === 0.75 || cue.volume === 0.25 || cue.volume === 0 ? cue.volume : 0.5,
        },
      ];
    }),
  ) as TimerAudioConfig;
}

export function timerAudioFromOptions(options: unknown): TimerAudioConfig {
  return normalizeTimerAudio(
    options && typeof options === 'object'
      ? (options as Record<string, unknown>).timerAudio
      : undefined,
  );
}
